module.exports = __webpack_public_path__ + "img/icon_chat_bottom.3816b099.jpg";